"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.DriversListWidget = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var react_router_dom_1 = require("react-router-dom");
var commonFunctions_1 = require("../../commonFunctions");
var FalconQuestionWidgetBase_1 = require("../FalconQuestionWidgetBase");
var journey_services_1 = require("@ferry/journey-services");
var DriversListWidget = /** @class */ (function (_super) {
    __extends(DriversListWidget, _super);
    function DriversListWidget(props) {
        var _this = _super.call(this, props) || this;
        _this.navigateToAddDriver = function () {
            var _a = _this.props, interaction = _a.interaction, engine = _a.engine;
            if (interaction.process === journey_services_1.INTERACTION_PROCESS_RENEWAL_PROPOSAL) {
                engine.navigate('addAdditionalDriverPresetPage', false);
                return;
            }
            if (interaction.product !== journey_services_1.PRODUCT_WOLF_MOTOR) {
                engine.navigate("vehicle".concat(_this.vehicleIndex, "AddDriverPage"));
            }
        };
        _this.navigateToEditDriver = function (index) {
            var _a = _this.props, interaction = _a.interaction, engine = _a.engine;
            if (interaction.process === journey_services_1.INTERACTION_PROCESS_RENEWAL_PROPOSAL) {
                engine.navigate("presetDriver".concat(index === 0 ? "PolicyHolder" : index - 1), false);
            }
        };
        _this.navigateToRemoveDriver = function (index) {
            var _a = _this.props, interaction = _a.interaction, engine = _a.engine;
            if (interaction.process === journey_services_1.INTERACTION_PROCESS_RENEWAL_PROPOSAL) {
                engine.navigate("removeDriver".concat(index - 1, "EntryPage"), false);
            }
        };
        _this.initialDriversList = [_this.props.interaction.policyHolder].concat(_this.props.interaction.additionalDrivers || []);
        _this.vehicleIndex = (0, commonFunctions_1.getIndexSetting)("vehicleIndex", _this.getSetting("vehicleIndex", undefined), _this.props.question.type);
        _this.showDriverCheckbox = _this.getSetting("showDriverCheckbox") === true;
        _this.showAddOrEditDriverOptions = _this.getSetting("showAddOrEditDriverOptions") === true;
        var vehicle = _this.props.interaction.vehicles[_this.vehicleIndex];
        var allDrivers = [_this.props.interaction.policyHolder].concat(_this.props.interaction.additionalDrivers || []);
        var drivers = [];
        // Set policy holder as main driver if no drivers set for the vehicle
        if (!vehicle.driverIds || vehicle.driverIds.length === 0) {
            vehicle.driverIds = [_this.props.interaction.policyHolder.personId];
            vehicle.mainDriverId = _this.props.interaction.policyHolder.personId;
            vehicle.numberOfDrivers += 1;
            if (journey_services_1.productHelper.isWolfMotor(_this.props.interaction)
                && (_this.props.interaction.process === journey_services_1.INTERACTION_PROCESS_MTA_REPLACE_CAR || _this.props.interaction.process === journey_services_1.INTERACTION_PROCESS_RENEWAL_PROPOSAL)
                && _this.props.interaction.additionalDrivers
                && _this.props.interaction.additionalDrivers.length > 0) {
                for (var _i = 0, _a = _this.props.interaction.additionalDrivers; _i < _a.length; _i++) {
                    var additionalDriver = _a[_i];
                    vehicle.driverIds.push(additionalDriver.personId);
                    vehicle.numberOfDrivers += 1;
                }
            }
        }
        drivers = vehicle.driverIds.map(function (driverId) { return allDrivers.find(function (driver) { return driverId === driver.personId; }); });
        _this.state = {
            vehicle: vehicle,
            drivers: drivers
        };
        _this.handleOnClickEvent = _this.handleOnClickEvent.bind(_this);
        _this.addDriver = _this.addDriver.bind(_this);
        _this.deleteDriver = _this.deleteDriver.bind(_this);
        return _this;
    }
    DriversListWidget.prototype.renderInputField = function () {
        var vehicle = this.props.interaction.vehicles[this.vehicleIndex];
        var vehicleInformation = "".concat(vehicle.make, " ").concat(vehicle.model, " ").concat(vehicle.registrationNumber);
        var vehicleRegNumber = '';
        if (vehicle.registrationNumber) {
            vehicleRegNumber = '(' + vehicle.registrationNumber + ')';
        }
        var labelWording = this.props.interaction.product !== journey_services_1.PRODUCT_WOLF_MOTOR ? "Who are the drivers of this ".concat(vehicle.make, ", ").concat(vehicle.model, " (").concat(vehicle.registrationNumber, ")?") :
            "Drivers of ".concat(vehicle.make, ", ").concat(vehicle.model, " ").concat(vehicleRegNumber);
        return ((0, jsx_runtime_1.jsxs)("div", { className: "falcon-checkbox form-group checkbox-margin-top-20 driver-list-wdg", children: [(0, jsx_runtime_1.jsx)("label", { className: "no-outline", children: labelWording }), (0, jsx_runtime_1.jsx)("div", { role: "group", "aria-label": "Who are the drivers of this ".concat((0, commonFunctions_1.trimParenthesesFromString)(vehicleInformation)), children: this.renderDrivers() }), this.showAddOrEditDriverOptions && this.props.interaction.additionalDrivers.length < 5 &&
                    (0, jsx_runtime_1.jsx)(react_router_dom_1.Link, { className: "add-another-driver", to: this.getAddAnotherDriverLink(), onClick: this.navigateToAddDriver, children: "Add another driver" })] }));
    };
    DriversListWidget.prototype.renderDrivers = function () {
        var _this = this;
        var product = this.props.interaction.product;
        var process = this.props.interaction.process;
        var relativeInteractionId = this.props.interaction.uistate.relativeInteractionId;
        return this.initialDriversList
            .map(function (driver, index) {
            var presetDriverSegment = index === 0 ? "PolicyHolder" : index - 1;
            var editDriverLink = process === journey_services_1.INTERACTION_PROCESS_RENEWAL_PROPOSAL
                ? "/journey/show/product/AnnualMotorInsurance/process/renewal/presetDriver".concat(presetDriverSegment, "/").concat(relativeInteractionId)
                : "/journey/init/product/".concat(journey_services_1.PRODUCT_NAME_WOLF_MOTOR, "/process/mtaEditDriverDetails/presetDriver").concat(presetDriverSegment, "/").concat(relativeInteractionId);
            var removeDriverLink = process === journey_services_1.INTERACTION_PROCESS_RENEWAL_PROPOSAL
                ? "/journey/show/product/AnnualMotorInsurance/process/renewal/removeDriver".concat(index - 1, "EntryPage/").concat(relativeInteractionId)
                : "/journey/show/product/".concat(journey_services_1.PRODUCT_NAME_WOLF_MOTOR, "/process/mtaRemoveDriver/removeDriver").concat(index - 1, "EntryPage/").concat(relativeInteractionId);
            return ((0, jsx_runtime_1.jsxs)("div", { className: "d-flex", children: [product === journey_services_1.PRODUCT_WOLF_MOTOR && _this.showDriverCheckbox &&
                        (0, jsx_runtime_1.jsxs)("div", { className: "form-check mr-3", children: [(0, jsx_runtime_1.jsx)("input", { className: "custom-control-input ".concat(_this.isChecked(driver.personId)), type: "checkbox", "aria-label": _this.getSetting("ariaLabel", ""), onChange: _this.handleOnClickEvent, value: driver.personId, onDoubleClick: _this.executeNativeEvent, name: driver.firstName, id: _this.props.question.name + driver.personId, checked: _this.isChecked(driver.personId), disabled: index === 0 }), (0, jsx_runtime_1.jsx)("label", { className: "custom-control-label", htmlFor: _this.props.question.name + driver.personId, "aria-label": "driver", children: (0, jsx_runtime_1.jsx)("div", { id: driver.personId, className: "checkbox-big" }) })] }), (0, jsx_runtime_1.jsxs)("p", { className: "mb-0 driver-name", children: [driver.firstName, " ", driver.lastName] }), _this.showAddOrEditDriverOptions && (product === journey_services_1.PRODUCT_WOLF_MOTOR || process === journey_services_1.INTERACTION_PROCESS_RENEWAL_PROPOSAL) &&
                        (0, jsx_runtime_1.jsx)(react_router_dom_1.Link, { className: "ml-2 pt-1 edit-driver-link", to: editDriverLink, onClick: function () { return _this.navigateToEditDriver(index); }, children: "edit" }), _this.showAddOrEditDriverOptions && product === journey_services_1.PRODUCT_WOLF_MOTOR && (index > 0) &&
                        (0, jsx_runtime_1.jsx)(react_router_dom_1.Link, { className: "ml-2 pt-1 edit-driver-link remove-driver", to: removeDriverLink, onClick: function () { return _this.navigateToRemoveDriver(index); }, children: "/ remove" })] }, driver.personId));
        });
    };
    DriversListWidget.prototype.handleOnClickEvent = function (event) {
        var _this = this;
        event.preventDefault();
        var changeDriverId = event.target.value;
        var vehicle = this.props.interaction.vehicles[this.vehicleIndex];
        if (changeDriverId === vehicle.mainDriverId) {
            return;
        }
        if (changeDriverId === this.props.interaction.policyHolder.personId) {
            this.props.onStateChange("vehicles[".concat(this.vehicleIndex, "].registeredKeeperId"), "");
        }
        var changed = false;
        if (vehicle.driverIds.length > 1) {
            vehicle.driverIds.forEach(function (driverId) {
                if (driverId === changeDriverId) {
                    _this.deleteDriver(changeDriverId);
                    changed = true;
                }
            });
        }
        if (!changed && !this.state.vehicle.driverIds.includes(changeDriverId)) {
            this.addDriver(changeDriverId);
        }
    };
    DriversListWidget.prototype.deleteDriver = function (driverPersonId) {
        var _a = this.state, vehicle = _a.vehicle, drivers = _a.drivers;
        var driverIdIndex = vehicle.driverIds.findIndex(function (id) { return id.localeCompare(driverPersonId) === 0; });
        if (driverIdIndex > -1) {
            vehicle.driverIds.splice(driverIdIndex, 1);
        }
        var driverIndex = drivers.findIndex(function (driver) { return driver.personId.localeCompare(driverPersonId) === 0; });
        if (driverIndex > -1) {
            drivers.splice(driverIndex, 1);
        }
        if (!vehicle.driverIds.includes(vehicle.mainDriverId)) {
            vehicle.mainDriverId = vehicle.driverIds[0];
        }
        vehicle.numberOfDrivers -= 1;
        this.setState({
            vehicle: vehicle,
            drivers: drivers
        });
        this.props.onStateChange("vehicles[".concat(this.vehicleIndex, "]"), this.state.vehicle);
        this.executeEvent("change");
        this.changelogRecorder.recordPage("change", this.props, "vehicles[".concat(this.vehicleIndex, "]"));
        var product = this.props.interaction.product;
        if (product === journey_services_1.PRODUCT_WOLF_MOTOR) {
            var additionalDrivers = this.props.interaction.additionalDrivers;
            var additionalDriverIndex = additionalDrivers.findIndex(function (driver) { return driver.personId.localeCompare(driverPersonId) === 0; });
            if (additionalDriverIndex > -1) {
                additionalDrivers.splice(additionalDriverIndex, 1);
            }
            this.props.onStateChange("additionalDrivers", additionalDrivers);
            this.executeEvent("change");
            this.changelogRecorder.recordPage("change", this.props, "additionalDrivers");
        }
    };
    DriversListWidget.prototype.addDriver = function (driverPersonId) {
        var _a = this.state, vehicle = _a.vehicle, drivers = _a.drivers;
        vehicle.driverIds.push(driverPersonId);
        vehicle.numberOfDrivers += 1;
        this.setState({
            vehicle: vehicle,
            drivers: drivers
        });
        this.props.onStateChange("vehicles[".concat(this.vehicleIndex, "]"), this.state.vehicle);
        this.executeEvent("change");
        this.changelogRecorder.recordPage("change", this.props, "vehicles[".concat(this.vehicleIndex, "]"));
        var product = this.props.interaction.product;
        if (product === journey_services_1.PRODUCT_WOLF_MOTOR) {
            var addedAdditionalDriver = this.initialDriversList.find(function (driver) { return driver.personId === driverPersonId; });
            var additionalDrivers = this.props.engine.getInteraction().additionalDrivers;
            additionalDrivers.push(addedAdditionalDriver);
            this.props.onStateChange("additionalDrivers", additionalDrivers);
            this.executeEvent("change");
            this.changelogRecorder.recordPage("change", this.props, "additionalDrivers");
        }
    };
    DriversListWidget.prototype.isChecked = function (checkedDriverId) {
        var vehicle = this.props.interaction.vehicles[this.vehicleIndex];
        var result = false;
        vehicle.driverIds.forEach(function (driverId) {
            if (driverId === checkedDriverId) {
                result = true;
            }
        });
        return result;
    };
    DriversListWidget.prototype.getAddAnotherDriverLink = function () {
        var interaction = this.props.interaction;
        if (interaction.process === journey_services_1.INTERACTION_PROCESS_RENEWAL_PROPOSAL) {
            return "/journey/show/product/AnnualMotorInsurance/process/renewal/addAdditionalDriverPresetPage/".concat(interaction.uistate.relativeInteractionId);
        }
        if (interaction.product === journey_services_1.PRODUCT_WOLF_MOTOR) {
            return "/journey/init/product/AnnualMotorInsurance/process/mtaAddPermanentDriver/preset/".concat(interaction.uistate.relativeInteractionId);
        }
        return '#';
    };
    return DriversListWidget;
}(FalconQuestionWidgetBase_1.FalconQuestionWidgetBase));
exports.DriversListWidget = DriversListWidget;
//# sourceMappingURL=DriversListWidget.js.map